import { render, staticRenderFns } from "./AppReleaseSingleDetails.vue?vue&type=template&id=49578584&"
import script from "./AppReleaseSingleDetails.vue?vue&type=script&lang=js&"
export * from "./AppReleaseSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports